// import i18n from "@i18n";
import { getProjectDashboardPageUrl } from "@Features/projects/utils/projectUrls";
import { getInspectionUrl, getViewerUrl } from "@Helpers";
import { convertDate } from "../../services/luxonHelper";
import _ from "lodash";
import { formCategories, getProjectMailThreadsPageUrl } from "../../../../helpers/constants";
import { Trans } from "react-i18next";

export const getNotificationParams = (notification: any) => {
  let text;
  let proPic;
  let redirectUrl;
  let type;
  const time = convertDate(Number(notification.createdDate), "getDifferenceTime");
  const id = notification.id;
  const userId = notification.userId;
  let username;
  let userName;
  let createdBy;
  let projectId;

  if (notification.type == "NOTIFICATION_TYPE_TRANSMITTAL_RECEIVED_TO") {
    const transmittalId = `TS-${notification.metadata.NOTIFICATION_DATA_TRANSMITTAL_COUNTER.value}`;
    const spaceName = notification.metadata.NOTIFICATION_DATA_FROM_SPACE_NAME.value;

    text = (
      <>
        <Trans
          i18nKey="notification_transmittalReceived"
          values={{
            transmittalId,
            spaceName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
    redirectUrl = `/project/${notification.metadata.NOTIFICATION_DATA_PROJECT_ID?.value}/listTransmittals/${notification.metadata.NOTIFICATION_DATA_TRANSMITTAL_ID?.value}?projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID?.value}`;
    type = "Transmittal";
  } else if (notification.type == "NOTIFICATION_TYPE_TRANSMITTAL_RECEIVED_CC") {
    const transmittalId = `TS-${notification.metadata.NOTIFICATION_DATA_TRANSMITTAL_COUNTER.value}`;
    const spaceName = notification.metadata.NOTIFICATION_DATA_TO_SPACE_NAME.value;
    userName = "";
    if (notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME) {
      userName = notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME.value;
    }
    text = (
      <>
        <Trans
          i18nKey="notification_transmittalSent"
          values={{
            transmittalId,
            spaceName,
            userName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
    redirectUrl = null;
    // redirectUrl = `/project/${notification.metadata.NOTIFICATION_DATA_PROJECT_ID?.value}/listTransmittals/${notification.metadata.NOTIFICATION_DATA_TRANSMITTAL_ID?.value}`;
    type = "Transmittal";
  } else if (notification.type == "NOTIFICATION_TYPE_PROJECT_USER_ADDED") {
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    projectId = notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value;
    text = (
      <>
        <Trans
          i18nKey="notification_addedToProject"
          values={{
            projectName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
    redirectUrl = getProjectDashboardPageUrl(projectId);
    type = "Project";
  } else if (notification.type == "NOTIFICATION_TYPE_PROJECT_USER_REMOVED") {
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    projectId = notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value;
    text = (
      <>
        <Trans
          i18nKey="notification_removedFromProject"
          values={{
            projectName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );

    type = "Project";
  } else if (notification.type == "NOTIFICATION_TYPE_PROJECT_USER_ROLE_CHANGED") {
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    const projectId = notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value;
    const oldRoleName = notification.metadata.NOTIFICATION_DATA_FROM_ROLE_NAME?.value;
    const newRoleName = notification.metadata.NOTIFICATION_DATA_TO_ROLE_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_roleChanges"
          values={{
            oldRoleName,
            newRoleName,
            projectName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
    redirectUrl = getProjectDashboardPageUrl(projectId);
    type = "Setting";
  } else if (notification.type == "NOTIFICATION_TYPE_SPACE_USER_ADDED") {
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    const spaceName = notification.metadata.NOTIFICATION_DATA_SPACE_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_addedToSpace"
          values={{
            spaceName,
            projectName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );

    type = "Space";
  } else if (notification.type == "NOTIFICATION_TYPE_COMMENT_ADDED") {
    let comment = notification.metadata.NOTIFICATION_DATA_COMMENT_CONTENT.value.substring(0, 100);
    type = "Issue";
    comment = comment.replace(/<[^>]+>/g, "");
    username = notification.metadata.NOTIFICATION_DATA_COMMENT_ADDED_BY.value;
    const issueId = notification.metadata.NOTIFICATION_DATA_ISSUE_ID.value;
    const FileId = notification.metadata.NOTIFICATION_DATA_FILE_ID?.value;
    const projectId = notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value;
    const issueCounter = notification.metadata.NOTIFICATION_DATA_ISSUE_COUNTER.value;
    const spaceId = _.get(notification, "metadata.NOTIFICATION_DATA_SPACE_ID.value");
    text = (
      <>
        <Trans
          i18nKey="notification_commentOn_Issue"
          values={{
            username,
            issueId: issueCounter,
            comment,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );

    const url = getViewerUrl({
      fileVersionId: FileId,
      issueId,
      spaceId,
      projectId,
    });
    redirectUrl = FileId && spaceId ? url : "";
  } else if (notification.type == "NOTIFICATION_TYPE_ISSUE_CREATED") {
    // let title = notification.metadata.NOTIFICATION_DATA_ISSUE_NAME.value;
    const ProjectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    username = notification.metadata.NOTIFICATION_DATA_ISSUE_CREATED_BY.value;
    const issueId = notification.metadata.NOTIFICATION_DATA_ISSUE_ID.value;
    const FileId = notification.metadata.NOTIFICATION_DATA_FILE_ID?.value;
    const projectId = notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value;
    const issueCounter = notification.metadata.NOTIFICATION_DATA_ISSUE_COUNTER.value;
    const spaceId = _.get(notification, "metadata.NOTIFICATION_DATA_SPACE_ID.value");
    // let awsFileName = notification.metadata.NOTIFICATION_DATA_AWS_FILE_NAME?.value;
    type = "Issue";
    // awsFileName = awsFileName?.substring(0, awsFileName.lastIndexOf("."));
    text = (
      <>
        <Trans
          i18nKey="notification_assingedAnIssue"
          values={{
            username,
            issueId: issueCounter,
            ProjectName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );

    const url = getViewerUrl({
      fileVersionId: FileId,
      issueId,
      spaceId,
      projectId,
    });
    redirectUrl = FileId && spaceId ? url : "";
  } else if (notification.type == "NOTIFICATION_TYPE_FILE_CONVERSION_COMPLETED") {
    const fileName = notification.metadata.NOTIFICATION_DATA_FILE_NAME.value;
    const fileVersionId = notification.metadata.NOTIFICATION_DATA_FILE_VERSION_ID.value;
    const spaceId = notification.metadata.NOTIFICATION_DATA_SPACE_ID.value;
    const projectId = _.get(notification, "metadata.NOTIFICATION_DATA_PROJECT_ID.value");
    type = "File";
    const url = getViewerUrl({
      fileVersionId,
      spaceId,
      projectId,
    });
    text = (
      <>
        <Trans
          i18nKey="notification_fileConversion"
          values={{
            fileName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );

    redirectUrl = url;
  } else if (notification.type == "NOTIFICATION_TYPE_TASK_USER_ADDED") {
    userName = "";
    if (notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME) {
      userName = notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME.value;
    }
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    const spaceName = notification.metadata.NOTIFICATION_DATA_SPACE_NAME.value;
    const taskName = `TSK-${notification.metadata.NOTIFICATION_DATA_TASK_NAME.value}`;
    text = (
      <>
        <Trans
          i18nKey="notification_taskAssigned"
          values={{
            userName,
            taskName,
            projectName,
            spaceName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );

    redirectUrl = `/project/${notification.metadata.NOTIFICATION_DATA_PROJECT_ID?.value}/listTask`;
    type = "Task";
  } else if (notification.type == "NOTIFICATION_TYPE_ESTIMATE_STATUS_UPDATED") {
    userName = notification.metadata?.NOTIFICATION_DATA_STATUS_CHANGED_BY?.value;
    const projectName = notification.metadata?.NOTIFICATION_DATA_PROJECT_NAME?.value;
    const spaceName = notification.metadata?.NOTIFICATION_DATA_SPACE_NAME?.value;
    const estimateName = notification.metadata?.NOTIFICATION_DATA_ESTIMATE_NAME?.value;
    const prevStatus = notification.metadata?.NOTIFICATION_DATA_ESTIMATE_PREVIOUS_STATUS?.value;
    const currentStatus = notification.metadata?.NOTIFICATION_DATA_ESTIMATE_CURRENT_STATUS?.value;
    type = "Estimate";
    text = (
      <>
        <Trans
          i18nKey="notification_estimateStatusChanges"
          values={{
            userName,
            estimateName,
            prevStatus,
            currentStatus,
            projectName,
            spaceName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_TASK_STATUS_CHANGED") {
    userName = "";
    if (notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME) {
      userName = notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME.value;
    }
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    const spaceName = notification.metadata.NOTIFICATION_DATA_SPACE_NAME.value;
    const taskName = `TSK-${notification.metadata.NOTIFICATION_DATA_TASK_NAME.value}`;
    let taskStatusName = notification.metadata.NOTIFICATION_DATA_TASK_STATUS_NAME.value;
    taskStatusName =
      taskStatusName.charAt(0).toUpperCase() + taskStatusName.substring(1).toLocaleLowerCase().replace(/_/g, " ");
    text = (
      <>
        <Trans
          i18nKey="notification_taskStatusChanges"
          values={{
            userName,
            taskName,
            taskStatusName,
            projectName,
            spaceName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
    redirectUrl = `/project/${notification.metadata.NOTIFICATION_DATA_PROJECT_ID?.value}/listTask/${notification.metadata.NOTIFICATION_DATA_TASK_VERSION_ID?.value}`;
    type = "Task";
  } else if (notification.type == "NOTIFICATION_TYPE_FILE_STATUS_CHANGED_UNDER_TRANSMITTAL") {
    type = "File";
    userName = "";
    if (notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME) {
      userName = notification.metadata.NOTIFICATION_DATA_FROM_USER_NAME.value;
    }
    const fileName = notification.metadata.NOTIFICATION_DATA_FILE_NAME?.value || "";
    let fromStatus = notification.metadata.NOTIFICATION_DATA_FROM_STATUS.value;
    let toStatus = notification.metadata.NOTIFICATION_DATA_TO_STATUS.value;
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    const projectId = notification.metadata.NOTIFICATION_DATA_PROJECT_PROJECT_ID?.value;
    const spaceName = notification.metadata.NOTIFICATION_DATA_SPACE_NAME.value;
    let note = "";
    if (notification.metadata.NOTIFICATION_DATA_NOTE) {
      note = notification.metadata.NOTIFICATION_DATA_NOTE.value;
    }

    fromStatus = fromStatus.charAt(0).toUpperCase() + fromStatus.substring(1).toLocaleLowerCase().replace(/_/g, " ");
    toStatus = toStatus.charAt(0).toUpperCase() + toStatus.substring(1).toLocaleLowerCase().replace(/_/g, " ");
    text = (
      <>
        <Trans
          i18nKey="notification_fileStatusChanges"
          values={{
            userName,
            fileName,
            fromStatus,
            toStatus,
            projectId,
            projectName,
            spaceName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );

    if (note) {
      text = (
        <>
          <Trans
            i18nKey="notification_textNote"
            values={{
              text,
              note,
            }}
            components={{ bold: <strong /> }}
          />
        </>
      );
    }
    type = "File";
  } else if (notification.type == "NOTIFICATION_TYPE_REVIEW_PENDING") {
    type = "Review";
    redirectUrl = `/review?reviewId=${notification.metadata.NOTIFICATION_DATA_REVIEW_ID.value}&spaceId=${notification.metadata.NOTIFICATION_DATA_SPACE_ID.value}&projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value}`;
    const reviewName = notification.metadata.NOTIFICATION_DATA_REVIEW_NAME.value;
    const reviewMsg = notification.metadata.NOTIFICATION_DATA_REVIEW_MESSAGE?.value || "";
    text = (
      <>
        <Trans
          i18nKey="notification_actionPedingForReview"
          values={{
            reviewMsg,
            reviewName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type === "NOTIFICATION_TYPE_REVIEW_FILE_VERSION_UPDATED") {
    type = "Review";
    redirectUrl = `/review?reviewId=${notification.metadata.NOTIFICATION_DATA_REVIEW_ID.value}&spaceId=${notification.metadata.NOTIFICATION_DATA_SPACE_ID.value}&projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value}`;

    const fileNames = notification.metadata.NOTIFICATION_DATA_FILES_NAMES?.value.join(", ");
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    const notifierName = notification.metadata.NOTIFICATION_DATA_NOTIFIER_NAME.value;
    const reviewName = notification.metadata.NOTIFICATION_DATA_REVIEW_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_fileUpdatedToLatestVersion"
          values={{
            fileNames,
            projectName,
            notifierName,
            reviewName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_ROLLBACK_REVIEW_PENDING") {
    type = "Review";
    redirectUrl = `/review?reviewId=${notification.metadata.NOTIFICATION_DATA_REVIEW_ID.value}&spaceId=${notification.metadata.NOTIFICATION_DATA_SPACE_ID.value}&projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value}`;
    const reviewName = notification.metadata.NOTIFICATION_DATA_REVIEW_NAME.value;
    const reviewMsg = notification.metadata.NOTIFICATION_DATA_REVIEW_MESSAGE?.value || "";
    text = (
      <>
        <Trans
          i18nKey="notification_actionPendingForRolledBackReview"
          values={{
            reviewMsg,
            reviewName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_REVIEW_CREATED") {
    type = "Review";
    redirectUrl = `/review?reviewId=${notification.metadata.NOTIFICATION_DATA_REVIEW_ID.value}&spaceId=${notification.metadata.NOTIFICATION_DATA_SPACE_ID.value}&projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value}`;
    const reviewName = notification.metadata.NOTIFICATION_DATA_REVIEW_NAME.value;
    const reviewMsg = notification.metadata.NOTIFICATION_DATA_REVIEW_MESSAGE?.value;
    text = (
      <>
        <Trans
          i18nKey="notification_reviewCreated"
          values={{
            reviewMsg,
            reviewName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_REVIEW_REVOKED") {
    type = "Review";
    redirectUrl = `/review?reviewId=${notification.metadata.NOTIFICATION_DATA_REVIEW_ID.value}&spaceId=${notification.metadata.NOTIFICATION_DATA_SPACE_ID.value}&projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value}`;
    const reviewName = notification.metadata.NOTIFICATION_DATA_REVIEW_NAME.value;
    const reviewMsg = notification.metadata.NOTIFICATION_DATA_REVIEW_MESSAGE?.value;
    text = (
      <>
        <Trans
          i18nKey="notification_reviewRevoked"
          values={{
            reviewMsg,
            reviewName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_REVIEW_DUE_DATE_APPROACHING") {
    type = "Review";
    redirectUrl = `/review?reviewId=${notification.metadata.NOTIFICATION_DATA_REVIEW_ID.value}&spaceId=${notification.metadata.NOTIFICATION_DATA_SPACE_ID.value}&projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value}`;
    const reviewName = notification.metadata.NOTIFICATION_DATA_REVIEW_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_reviewDueDateApproaching"
          values={{
            reviewName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_REVIEW_OVERDUE") {
    type = "Review";
    redirectUrl = `/review?reviewId=${notification.metadata.NOTIFICATION_DATA_REVIEW_ID.value}&spaceId=${notification.metadata.NOTIFICATION_DATA_SPACE_ID.value}&projectId=${notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value}`;
    const reviewName = notification.metadata.NOTIFICATION_DATA_REVIEW_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_reviewOverdue"
          values={{
            reviewName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_MAIL_ACKNOWLEDGED") {
    type = "Mailbox";
    redirectUrl = getProjectMailThreadsPageUrl(
      notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value,
      notification.metadata.NOTIFICATION_DATA_MAIL_INSERTED_ID.value,
    );
    const userName = notification.metadata.NOTIFICATION_DATA_MAIL_ACKNOWLEDGE_BY_NAME.value;
    const mailSubject = notification.metadata.NOTIFICATION_DATA_MAIL_SUBJECT.value;
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_mailAcknowledged"
          values={{
            userName,
            mailSubject,
            projectName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_RECEIVED_MAIL_TO") {
    type = "Mailbox";
    redirectUrl = getProjectMailThreadsPageUrl(
      notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value,
      notification.metadata.NOTIFICATION_DATA_MAIL_INSERTED_ID.value,
    );
    const subject = notification.metadata.NOTIFICATION_DATA_MAIL_SUBJECT.value;
    const sendersName = notification.metadata.NOTIFICATION_DATA_MAIL_SENDERS_NAME.value;
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_mailRecieved"
          values={{
            sendersName,
            projectName,
            subject,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_RECEIVED_MAIL_CC") {
    type = "Mailbox";
    redirectUrl = getProjectMailThreadsPageUrl(
      notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value,
      notification.metadata.NOTIFICATION_DATA_MAIL_INSERTED_ID.value,
    );
    const mailSubject = notification.metadata.NOTIFICATION_DATA_MAIL_SUBJECT.value;
    const sendersName = notification.metadata.NOTIFICATION_DATA_MAIL_SENDERS_NAME.value;
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value.value;
    text = (
      <>
        <Trans
          i18nKey="notification_mailRecievedCC"
          values={{
            sendersName,
            projectName,
            mailSubject,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_TYPE_MAIL_DUE_DATE_EXPIRED") {
    type = "Mailbox";
    redirectUrl = getProjectMailThreadsPageUrl(
      notification.metadata.NOTIFICATION_DATA_PROJECT_ID.value,
      notification.metadata.NOTIFICATION_DATA_MAIL_INSERTED_ID.value,
    );
    const responseType =
      notification.metadata.NOTIFICATION_DATA_RESPONSE_TYPE.value == "REPLY_BY" ? "Reply" : "Acknowledge";
    const mailSub = notification.metadata.NOTIFICATION_DATA_MAIL_SUBJECT.value;
    const projectName = notification.metadata.NOTIFICATION_DATA_PROJECT_NAME.value;
    text = (
      <>
        <Trans
          i18nKey="notification_mailExpired"
          values={{
            responseType,
            mailSub,
            projectName,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  } else if (notification.type == "NOTIFICATION_DATA_FORM_CREATED") {
    createdBy = notification.metadata.NOTIFICATION_DATA_FORM_CREATEDBY.value;
    const title = notification.metadata.NOTIFICATION_DATA_FORM_TITLE.value;
    const projectId = notification.metadata.NOTIFICATION_DATA_FORM_PROJECTID.value;
    const resourceId = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_RESOURCEID.value");
    const contractId = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_CONTRACTID.value");
    const resourceType = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_RESOURCE_TYPE.value");
    const task = notification.metadata.NOTIFICATION_DATA_FORM_TASK?.value;

    if (resourceType === formCategories.inspection) {
      type = "inspectionForm";
    } else if (resourceType === formCategories.progressUpdates) {
      type = "progressUpdateForm";
    } else if (resourceType === formCategories.bills) {
      type = "billForm";
    } else if (resourceType === formCategories.changeOrder) {
      type = "changeOrderForm";
    } else {
      type = resourceType;
    }
    if (task == "formCreated") {
      text = (
        <Trans
          i18nKey="notification_formCreated"
          values={{
            createdBy,
            title,
          }}
          components={{ bold: <strong /> }}
        />
      );
    } else if (task == "levelSubmit") {
      text = (
        <Trans
          i18nKey="notification_formLevelSubmit"
          values={{
            title,
          }}
          components={{ bold: <strong /> }}
        />
      );
    } else if (task == "finalSubmit") {
      text = (
        <Trans
          i18nKey="notification_formSubmit"
          values={{
            title,
          }}
          components={{ bold: <strong /> }}
        />
      );
    } else if (task == "rollback") {
      text = (
        <Trans
          i18nKey="notification_formRollBackSubmit"
          values={{
            title,
          }}
          components={{ bold: <strong /> }}
        />
      );
    } else if (task == "formRejected") {
      text = (
        <Trans
          i18nKey="notification_formRejected"
          values={{
            title,
          }}
          components={{ bold: <strong /> }}
        />
      );
    } else if (task == "formApproved") {
      text = (
        <Trans
          i18nKey="notification_formApproved"
          values={{
            title,
          }}
          components={{ bold: <strong /> }}
        />
      );
    }

    redirectUrl = resourceId
      ? getInspectionUrl({
          projectId,
          resourceId,
          contractId,
          resourceType,
        })
      : null;
  } else if (notification.type == "NOTIFICATION_DATA_FILE_UPLOADED") {
    type = "File";
    const files = notification.metadata.NOTIFICATION_DATA_FILE_ESCROW_BATCH_FILES.value;
    const batchId = notification.metadata.NOTIFICATION_DATA_FILE_ESCROW_BATCH_ID.value;
    text = (
      <>
        <Trans
          i18nKey="notification_fileUploaded"
          values={{
            files,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
    redirectUrl = `/escrowFiles/${batchId}`;
  } else if (notification.type == "NOTIFICATION_DATA_FORM_DUEDATE_NOTIFICATION") {
    type = "GeneralForms";
    createdBy = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_PROJECTID.value");
    const formTitle = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_TITLE.value");
    const formNo = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_NO.value");
    const formDueDate = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_DUEDATE.value");
    const projectId = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_PROJECTID.value");
    const resourceId = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_RESOURCEID.value");
    const contractId = _.get(notification, "metadata.NOTIFICATION_DATA_FORM_CONTRACTID.value");
    redirectUrl = getInspectionUrl({ projectId, resourceId, contractId });
    const formConvertedDueDate = convertDate(Number(formDueDate), "dateForToolTipModal");
    text = (
      <>
        <Trans
          i18nKey="notification_formExpired"
          values={{
            formNo,
            formTitle,
            formConvertedDueDate,
          }}
          components={{ bold: <strong /> }}
        />
      </>
    );
  }

  return {
    proPic,
    text,
    time,
    id,
    redirectUrl,
    createdDate: notification.createdDate,
    type,
    read: notification.read,
    userId,
    username,
    userName,
    createdBy,
    projectId,
  };
};
